import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environments';
import { Observable } from 'rxjs';
import { StatesResponse } from '../interfaces/states.interface';
import { ReservationPayload } from '../interfaces/reservation-payload.interface';

@Injectable({
  providedIn: 'root'
})
export class ReservationService {

  constructor(private http: HttpClient) {}

  getAllStates(): Observable<StatesResponse> {
    return this.http.get<StatesResponse>(`${environment.RESERVE_URL}/Place/States`);
  }

  getCitiesByState(acronymState: string): Observable<StatesResponse> {
    return this.http.get<StatesResponse>(`${environment.RESERVE_URL}/Place/Cities/State/${acronymState}`);
  }

  getBranchesByCity(city: string): Observable<StatesResponse> {
    return this.http.get<StatesResponse>(`${environment.RESERVE_URL}/Place/Branches/City/${city}`);
  }

  getHallByBranch(branchId: string): Observable<StatesResponse> {
    return this.http.get<StatesResponse>(`${environment.RESERVE_URL}/Place/Halls/Branch/${branchId}`);
  }

  getPeoples(hallId: string, branchId: string): Observable<any> {
    return this.http.get<any>(`${environment.RESERVE_URL}/Place/Branch/${branchId}/Hall/${hallId}`);
  }

  getDates(hallId: string, branchId: string, quantity: number): Observable<any> {
    return this.http.get<any>(`${environment.RESERVE_URL}/Availability/Dates?BranchId=${branchId}&HallId=${hallId}&Quantity=${quantity}`);
  }

  getHour(hallId: string, branchId: string, quantity: number, day: string): Observable<any> {
    return this.http.get<any>(`${environment.RESERVE_URL}/Availability/Hours?BranchId=${branchId}&HallId=${hallId}&Quantity=${quantity}&Date=${day}`);
  }

  createReservation(body: ReservationPayload): Observable<any> {
    return this.http.post<any>(`${environment.RESERVE_URL}/Reservation`, body);
  }

  putReservation(body: any): Observable<any> {
    return this.http.put<any>(`${environment.RESERVE_URL}/Reservation`, body);
  }

  getBranchById(branchId: string): Observable<any> {
    return this.http.get<any>(`${environment.RESERVE_URL}/Branch/${branchId}`);
  }

  getOcasion(): Observable<any> {
    return this.http.get<any>(`${environment.RESERVE_URL}/Occasion`);
  }

  verifyCPF(cpf: string): Observable<any> {
    return this.http.get<any>(`${environment.RESERVE_URL}/Cashback/${cpf}`);
  }
}
